// extracted by mini-css-extract-plugin
export default {"infoIcon":"ChangeIngestionMode_infoIcon__1_e5R"};